export function Play(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="17"
        height="18"
        viewBox="0 0 17 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.76884 0.410958C4.28986 0.141531 3.74956 0 3.2 0C1.43269 0 0 1.43269 0 3.2V14.3606C0 14.9102 0.141531 15.4505 0.410958 15.9294C1.2774 17.4698 3.22849 18.0161 4.76884 17.1497L14.6894 11.5693C15.2002 11.282 15.6223 10.8599 15.9096 10.3491C16.776 8.8088 16.2297 6.85771 14.6894 5.99126L4.76884 0.410958ZM2.4 3.2C2.4 2.75817 2.75817 2.4 3.2 2.4C3.33739 2.4 3.47246 2.43538 3.59221 2.50274L13.5128 8.08304C13.8978 8.29966 14.0344 8.78743 13.8178 9.17251C13.746 9.30021 13.6405 9.40574 13.5128 9.47757L3.59221 15.0579C3.20712 15.2745 2.71935 15.1379 2.50274 14.7528C2.43538 14.6331 2.4 14.498 2.4 14.3606V3.2Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
